// based on rc-trigger 2.6.2
import Trigger from './Trigger';
export default Trigger;
